import { PORTFOLIO_TYPE } from '@/constants'

import { PortfolioApprovalTagContent } from '../constants'

export const calculateApprovalMessageBoxContent = (
  portfolioApprovalTagContent: PortfolioApprovalTagContent,
  type: keyof typeof PORTFOLIO_TYPE
) => {
  const result = { title: '', description: '' }
  if (portfolioApprovalTagContent === PortfolioApprovalTagContent.EDITS_REJECTED) {
    result.title = 'Edits were recently rejected'
    result.description = `The ${PORTFOLIO_TYPE[type].value} portfolio has been restored to its previous state`
  } else if (portfolioApprovalTagContent === PortfolioApprovalTagContent.NEW_REJECTED) {
    result.title = `This ${PORTFOLIO_TYPE[type].value} portfolio was recently rejected`
    result.description =
      'This template will automatically be removed in 5 days. You can still edit and resubmit within this period.'
  }
  return result
}
